import axiosClient from "../../../../../system/helpers/axiosConfig";

export const postAdminEditMessage = (params) => {
  return axiosClient
    .post("/api/admin/im/message/edit", params)
    .then((r) => r.data);
};
